import { jsx as _jsx } from "react/jsx-runtime";
import { ForumSectionItem } from "@bluframe/mightychroma-mightytool-ui";
const Add = ({ onCancel, onSave }) => (_jsx(ForumSectionItem, { isAdd: true, onCancel: onCancel, onSave: onSave }));
export default Add;
